import React, { useContext, useEffect, useState } from 'react';
import { Button, Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
//context
import { UserContext } from 'context/userContext';
//constants
import { searchChoiceData } from 'constants';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Select from 'components/userzone/CustomSelectSimple'

const SearchBarWithData = () => {
  const { t } = useTranslation(['header', 'list']);
  const { searchData, setSearchData } = useContext(UserContext);
  const [inputValue, setInputValue] = useState(searchData.value);
  const { assignedLibrary } = useAssignedLibrary();
  const [selectedOption, setSelectedOption] = useState(searchData.searchType);
  const navigate = useNavigate();

  const FORM_RADIO_OPTIONS_DIVISIONS = searchChoiceData(t);
  const options = FORM_RADIO_OPTIONS_DIVISIONS[0].optionsData.map(option => ({
    value: option.value,
    label: option.label
  }));

  const selectedOptionObj = options.find(option => option.value === selectedOption) || null;

  useEffect(() => {
    setInputValue(searchData.value);
    setSelectedOption(searchData.searchType || '');
  }, [searchData]);

  const handleSearch = () => {
    setSearchData({ value: inputValue, searchType: selectedOption });
    const URLqueryParametersManager = new URLSearchParams({ [selectedOption]: inputValue });
    navigate(`/${assignedLibrary}/lista/search?${URLqueryParametersManager.toString()}`);
  };

  return (
    <Col className="search-bar-with-data">
      <Form.Group controlId="formSearchValue">
        <Form.Control
          placeholder={t('buscarLibros')}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Form.Group>
      <Form.Group controlId="formSearchType" className="mt-3">
        <Select
          options={options}
          placeholder={t('select', { ns: 'list' })}
          value={selectedOptionObj}
          onChange={(selected) => setSelectedOption(selected ? selected.value : '')}
        />
      </Form.Group>
      <Button className="mt-3 w-100" onClick={handleSearch}>
        {t('search')}
      </Button>
    </Col>
  );
};

export default SearchBarWithData;
